export default class ActualReason {
  constructor(problemId = '', description = '') {
    this.problemId = problemId
    this.description = description
  }

  mapFromApi(responseData) {
    this.problemId = responseData.ProblemId
    this.description = responseData.Description
  }
}
